export const MAX_FILE_UPLOAD_SIZE: number = Number(process.env.REACT_APP_MAX_FILE_UPLOAD_SIZE) || 5000000;